import React, { Component } from "react";

// import Icon from "../../prefabs/icon/view";



class NavListItem extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }



  // ===============================================================================================
  onClick(e) {
    e.preventDefault();
    if (this.props.active !== this.props.current) {
      // console.log(`HEADER:\n Changing ${this.props.type} field, ${e.target.value}`);
      this.props.handleClick(this.props.current);
    }
  }



  // ===============================================================================================
  render() {
    return (
      <div className={"floating-header__list-item" +
        ((this.props.active === this.props.current) ? " floating-header__list-item--active" : "") +
        ((this.props.active !== this.props.current) ? " floating-header__list-item--inactive" : "")}>
        <button
          className={"floating-header__item-btn floating-header__item-btn--" + this.props.id}
          tabIndex="-1"
          onClick={this.onClick}>
            {this.props.current - 1}
          {/* <Icon type={"sec-" + this.props.id}/> */}
        </button>
        <span className="floating-header__item-title">{this.props.title}</span>
      </div>
    );
  }

}



export default NavListItem
